<template>
  <div id="demo">
		<div style="">
			<div class="table-box" ref="scroll" >
				<!-- 表头 -->
				<!-- <div class="table-th" ref="table_th">
					<div class="table-th-cell" v-for="(item,index) in rableTitle" :key="index" :style="{'width':item.width + 'px'}" >
						{{item.title}}
						<a-icon type="caret-down" style="color: #999;margin-left: 4px;font-size: 12px;" />
					</div>
				</div> -->
				
				<!-- 表格内容 -->
				<!-- <div v-for="(item,index) in 20" :key="index" class="table-td" >
					<div class="table-td-cell">
						2022-5-26
					</div>
				</div>
				
				<div style="position: fixed;right: 0;top:0;z-index: 6;background-color: #fff;height: 100%;width: 30px;">
					
				</div> -->
				
				<!-- <div class="out_box"  ref="out_box"  @mousedown="mouseDown" @mouseup="mouseUp" @mouseout="mouseOut">
					<div :style="{'transform':'translateX(' + scroll_left + 'px)',}" class="in_box"  ref="in_box" ></div>
				</div> -->
				
			</div>
		</div>
		<!-- <audience-target @receive="receive" :curValue="curValue" :extensions="{}"/> -->
  </div>
</template>

<script>
export default {
  name: 'demo',
  data() {
    return {
		rableTitle: [
			{title:"投放日期",width:110,},
			{title:"投放金额(元)",width:140,},
			{title:"净投放金额(返点后)",width:180,},
			{title:"充值金额(元)",width:140,},
			{title:"分成金额(元)",width:140,},
			{title:"总ROI",width:110,},
			{title:"首日ROI",width:110,},
			{title:"近7日ROI",width:120,},
			{title:"粉丝数",width:110,},
			{title:"付费人数",width:110,},
			{title:"当天付费人数",width:140,},
			{title:"当天付费成本(元)",width:170,},
			{title:"ROI_前7天",width:130,},
			{title:"ROI_前6天",width:130,},
			{title:"ROI_前5天",width:130,},
			{title:"ROI_前4天",width:130,},
			{title:"ROI_前3天",width:130,},
			{title:"ROI_前2天",width:130,},
			{title:"ROI_前1天",width:130,},
		],
		//滚动条参数
		firstX: "", // 第一次坐标
		outBoxWidth: "", // 滚动条长度
		moveWidth: "", // 可移动的长度
		windowWidth: document.body.clientWidth - 60, //可视宽度
		tabel_width: 0,
		table_screen: 0, // 可视宽度与表格实际宽度的比值
		scroll_left: 0, // 滚动条距离左边的移动距离
		scroll_x_left: 0, // 滚动条距离左边的移动距离
		last_left: 0, // 上一次移动的距离-自己写的滚动条
		last_x_left: 0, // 上一次移动的距离-scroll-x的滚动距离
		scroll_allow: true,
		//滚动条参数
		
		curValue: { }
    };
  },
	mounted() {
		const that = this;
  // 	    window.onresize = function() {
  // 	      //监听浏览器窗口
  // 	      that.ifmove();
  // 	    };
  // 	    that.ifmove(); //页面进来先判断
		
		// console.log("that.$refs.table_th.style",this.$refs.table_th.scrollWidth)
	},
	methods: {
		receive(value) {
			console.log("value",value);
		      this.curValue = value
		    },
			
		ifmove() {
	        let that = this;
			
			that.tabel_width = this.$refs.table_th.scrollWidth // 表格的实际宽度，包括溢出部分
	        that.windowWidth = document.body.clientWidth - 60; // 可视/屏幕宽度
			
	        if (that.windowWidth <= that.tabel_width) { // 如果可视宽度小于等于表格实际宽度，就显示滚动条
				that.$refs.out_box.style.display = "block"; // 显示滚动条
				
				that.table_screen = that.windowWidth / that.tabel_width // 获取可视宽度与表格实际宽度的比值
				
				that.$refs.in_box.style.width = that.table_screen * that.windowWidth + "px"; //显示区域占百分比，在滚动条显示
				console.log('width',that.table_screen * that.windowWidth + "px")
				
				that.moveWidth = (1 - that.windowWidth / that.tabel_width) * that.windowWidth; //获取可移动宽度
				console.log("that.moveWidth可移动宽度",that.moveWidth)
			
			} else {
	          that.$refs.out_box.style.display = "none";
	        }
	    },
		// 添加的横向滚动函数
		scrollEvents(event){
			let that = this;
			// console.log("event.screenX",event.screenX) // 鼠标在网页2上横向移动的距离
			if(that.scroll_allow){
				
			
				let e = event || window.event;
				console.log("zzzzzz",that.last_left + (event.screenX - that.firstX) <= that.moveWidth)
				// 正数向右移动，负数向左移动
				if(that.last_left + (event.screenX - that.firstX) >= 0 && that.last_left + (event.screenX - that.firstX) <= that.moveWidth){
					// console.log("aaaa",(event.screenX - that.firstX) / that.table_screen)
					that.scroll_left = that.last_left + (event.screenX - that.firstX)
					
					that.scroll_x_left = that.last_left + ((event.screenX - that.firstX) / that.table_screen)
					
					that.$refs.scroll.scrollLeft = that.last_x_left + ((event.screenX - that.firstX) / that.table_screen)
					
					console.log('that.scroll_left',that.scroll_left)
					console.log('that.scroll_x_left',that.scroll_x_left)
					// console.log('that.$refs.scroll.scrollLeft',that.$refs.scroll.scrollLeft)
				}
			}
			
		},
		//滚动条事件
		mouseDown(event) {
			
		  let e = event || window.event;
		  let that = this;
		  that.scroll_allow = true
		  this.firstX = e.clientX;
			
		  this.$refs.in_box.addEventListener("mousemove", that.scrollEvents);
		},
		mouseUp(e) {
			console.log('mouseUp',this.scroll_left)
			// this.f = 0;
			this.scroll_allow = false
			this.$refs.in_box.removeEventListener("mousemove",this.scrollEvents)
			
			this.last_left = this.scroll_left // 保存上一次移动的距离
			if(this.scroll_left === 0){
				this.last_x_left = 0
			}
			else {
				this.last_x_left = this.scroll_x_left
			}
		},
		// 鼠标移出该元素
		mouseOut(e){
		// 	console.log('鼠标移出该元素，mouseOut',this.scroll_left)
		// 	this.scroll_allow = false
		// 	this.$refs.in_box.removeEventListener("mousemove",this.scrollEvents)
		// 	// 移除该事件
		// 	this.last_left = this.scroll_left // 保存上一次移动的距离
			
		// 	if(this.scroll_left === 0){
		// 		this.last_x_left = 0
		// 	}
		// 	else {
		// 		this.last_x_left = this.scroll_x_left
		// 	}
		}
	  
	  
	}
}
</script>

<style scoped>
.table-box {
	position: relative;
	width: 100%;
	overflow-x: visible;
}
.table-th {
	position:sticky;
	top: 65px;
	z-index:3;
	display: flex;
	align-items: center;
}
.table-th-cell {
	padding: 16px;
	cursor: pointer;
	color: #060606;
	flex-shrink: 0;
	background-color: #fbfbfb;
	/* border-bottom: 1px solid #e8e8e8; */
	user-select: none;
}
.table-th-cell:hover {
	background-color: #eee;
}

.table-td {
	
	display: flex;
	align-items: center;
}
.table-td-cell {
	padding: 16px;
	flex-shrink: 0;
	cursor: default;
	/* border-bottom: 1px solid #e8e8e8; */
	position: sticky;
	left: 0;
	bottom: 0;
}

.out_box {
	position: sticky;
	left: 0;
	bottom: 0;
	background-color: #666;
	border-radius: 8px;
	height: 16px;
}
.in_box {
	background-color: #999;
	height: 16px;
	border-radius: 8px;
}
</style>